'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _utils = require('../utils');

var _functional = require('../utils/functional');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var description = (0, _functional.getElement)('.' + context.className + '_Description');

  el.addEventListener('click', function (evt) {
    (0, _utils.scrollToY)((0, _utils.getOffsetTop)(description));
  });
}